import {Component, OnInit, OnDestroy, OnChanges, ViewChild} from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ProjectService } from '../project/project.service';
import { MediaQuestion } from '../model/media-question';
import { DataNavigationState } from '../model/data-navigation-state';
import { SearchFilters } from '../model/search-filter/search-filters';
import { ApplicationContext } from '../model/application-context';
import {Synchro} from '../model/synchro';
import {ReportsComponent} from '../reports/reports.component';
import {RegisterDeviceComponent} from '../deviceRegistrationModal/register-device.component';
import {GenericModalComponent} from '../modal/generic-modal.component';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {FileChooserComponent} from '../FileChooser/file-chooser.component';
import {TranslateService} from '../translate/translate.service';
import {ReportFilterComponent} from '../reportFilter/reportFilter.component';
import {Project} from '../model/project';
import {ProjectFormUtil} from '../model/FormUtil/projectFormUtil';
import {Client} from '../model/client';
import {ClientFormUtil} from '../model/FormUtil/clientFormUtil';
import {FormModel} from '../model/forms/form-model';
import {CreateObjectDialogComponent} from '../createObjectDialog/create-object-dialog.component';
import {ClientManagerComponent} from '../project/clientManager/client-manager.component';
import {NotificationComponent} from '../notification/notification.component';
import {Questionnaire} from '../model/questionnaire';

@Component({
    selector: 'questionnaire-data',
    template: `
        <loading *ngIf="_isLoading"></loading>
        <div class="row" *ngIf="!_isLoading">
            <div class="col">
                <div class="card-body">
                  <data-navbar (FilterChange)="onSearchFilterChange()" (Download)="onDownload($event)" (ReportExcel)="onExcelReport()" (ReportHtml)="onHtmlReport()" [app-context]="_appContext"></data-navbar>
                    <div class="card">
                      <div class="card-body">
                          <div *ngIf="_appContext.dataNavigationState.selectedView!='respondents' && _appContext.dataNavigationState.selectedView!='stats' && _appContext.dataNavigationState.selectedView!='htmlRapport'" class="backgroundPanel">
                            <p class="textWelcome"><span style="margin-right:15px;"><img style="height:72px;" alt="taskProgrammer" src="../../assets/images/Actions-view-calendar-tasks-icon.png"></span>Any incoming project? Pick a task to perform ...</p>
                              <img *ngIf="_appContext.dataNavigationState.selectedView=='report'" alt='background' class='backgroundImg' src="../../assets/images/Excel.jpg">
                              <table class="taskList">
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView!='report'">
                                    <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                    <td class="task" (click)="RegisterDevice()">Register a device</td>
                                  </tr>
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView=='report'">
                                      <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                      <td class="task"  (click)="onHtmlReport()">Reporting Tool</td>
                                  </tr>
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView=='report'">
                                      <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                      <td class="task" (click)="onExcelReportQuickLink()" >Generate Excel Report</td>
                                  </tr>
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView!='report'">
                                      <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                      <td class="task" (click)="onReport()">Reports</td>
                                  </tr>
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView!='report'">
                                      <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                      <td class="task"  (click)="getRegisteredDevices()">View Registered Devices</td>
                                  </tr>
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView!='report'">
                                      <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                      <td class="task" (click)="showAddProject()" >Add Project</td>
                                  </tr>
                                  <tr *ngIf="_appContext.dataNavigationState.selectedView!='report'">
                                      <td><img alt="arrowIcon" class="icon" src="../../assets/images/290.png"></td>
                                      <td class="task" (click)="launchClientManager()">Manage Clients</td>
                                  </tr>
                              </table>
                              <notificationSlider></notificationSlider>
                              <div style="margin-top:370px;"><a href="https://nomadlogic.atlassian.net"><img style="height:72px;margin-right:45px;float: right;" alt="helpViaAtlassian" src="../../assets/images/168.png" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="Help"></a></div>
                          </div>
                          <div [ngSwitch]="_appContext.dataNavigationState.selectedView">
                          <ng-container *ngSwitchCase="'respondents'">
                            <div *ngIf="(this._appContext.synchros != null && this._appContext.synchros.length > 0)">
                                <div [style.display]="singleRespondentView ? 'none' : 'inline'">
                                  <div class="dropdown">
                                    <a class="btn btn-outline-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      {{this.selectedResultsPerPage}}
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                      <li class="dropdown-item" style="list-style: none" value="1" (click)="onSelected($event)">1</li>
                                      <li class="dropdown-item" style="list-style: none" value="5" (click)="onSelected($event)">5</li>
                                      <li class="dropdown-item" style="list-style: none" value="10" (click)="onSelected($event)">10</li>
                                      <li class="dropdown-item" style="list-style: none" value="15" (click)="onSelected($event)">15</li>
                                      <li class="dropdown-item" style="list-style: none" value="25" (click)="onSelected($event)">25</li>
                                      <li class="dropdown-item" style="list-style: none" value="50" (click)="onSelected($event)">50</li>
                                      <li class="dropdown-item" style="list-style: none" value="75" (click)="onSelected($event)">75</li>
                                      <li class="dropdown-item" style="list-style: none" value="100" (click)="onSelected($event)">100</li>
                                    </div>
                                    <div class="btn-group btn-group-toggle controlBtn" data-toggle="buttons">
                                      <label  (click)="changeRespondentView('by-synchro')" [class.disabled]="_appContext.dataNavigationState.respondentsView == 'by-synchro'" type="button" class="btn btn-primary">
                                        <input type="radio" name="options" id="option1" autocomplete="off" data-toggle="tooltip" data-placement="bottom" title="Synchro grouped View"> <span aria-hidden="true"><i class="far fa-list-alt"></i></span>
                                      </label >
                                      <label (click)="changeRespondentView('by-list')" [class.disabled]="_appContext.dataNavigationState.respondentsView == 'by-list'" type="button" class="btn btn-primary">
                                        <input type="radio" name="options" id="option1" autocomplete="off" data-toggle="tooltip" data-placement="bottom" title="List View"><span aria-hidden="true"><i class="fas fa-list-ul"></i></span>
                                      </label>
                                    </div>
                                    <div class="galleryBtn">
                                      <button type="button" class="btn btn-primary" (click)="galleryViewer()" data-toggle="tooltip" data-placement="bottom" title="View gallery of the below respondents">Image Gallery</button>
                                    </div>
                                  </div>
                                    <div class="postSyncBtnAllResp">
                                        <button type="button" class="btn btn-success" (click)="executePostSynchro()" data-toggle="tooltip" data-placement="bottom" title="Run email/sms post-sync actions on all the respondents">Run Post Synchro</button>
                                    </div>
                                </div>
                                <div [ngSwitch]="_appContext.dataNavigationState.respondentsView">
                                    <ng-container *ngSwitchCase="'by-synchro'">
                                        <respondents-by-synchro *ngIf="this._appContext.synchros != null"  [synchro_by_page]="this.selectedResultsPerPage" [synchros]="this._appContext.synchros" [navigation-state]="this._appContext.dataNavigationState" (_explodeSynchroEvent) = "explodeSynchro($event)" ></respondents-by-synchro>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'by-list'">
                                        <respondents-by-list *ngIf="this._appContext.synchros != null" [respondents_by_page]="selectedResultsPerPage" [totalNbRespondents]="this._totalRespondents" [questionnaireID]="this._appContext.questionnaire.id" [navigation-state]="this._appContext.dataNavigationState" [deviceID]="this._deviceID" (respondentSelect)="singleRespondentSelected($event)"></respondents-by-list>
                                    </ng-container>
                                </div>
                            </div>
                            <loadingCircles *ngIf="_respondentQueryTerminated == false"></loadingCircles>
                            <div *ngIf="(this._appContext.synchros == null || this._appContext.synchros.length == 0) && _respondentQueryTerminated == true" style="padding:10px;">
                              No respondent yet !
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'stats'">
                            <div *ngIf="this._appContext.statistics != null">
                              <statistics-component [statistics]="this._appContext.statistics"></statistics-component>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'htmlRapport'">
                            <div *ngIf="this._appContext.statistics != null">
                              <reports [appContext]="this._appContext"  [totalRespondent]="this._totalRespondents"></reports>
                            </div>
                          </ng-container>
                          <div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <registerDevice (newDevice)="DeviceRegistered($event)"></registerDevice>
        <generic-info-modal (OkClick)="onOk()"></generic-info-modal>
        <file-chooser></file-chooser>
        <create-object-dialog (NewObjectEvent)="onNewEvent($event)" [modelObject]="intentModel" [formModel]="formModel" [wizardTitle]="formModel.title"></create-object-dialog>
        <reportFilter [availablePhysicalDevices]="this.availablePhysicalDevices" [availableTerminals]="this.availableTerminals" [appContext]="_appContext"></reportFilter>
        <clientManager (error)="errorThrow($event)"></clientManager>
    `,
  styles:[`.card{padding: 10px;}
  .task{color:white;font-weight: bold;font-family:"Verdana"; font-size:small;margin-top:15px;padding-left:5px;}
  .icon{height:20px;}
  .textWelcome{color:white;font-size: large;font-family: "Arial", sans-serif;font-weight: bold;position: relative; top:10%;left:5%;}
  .taskList{position: relative; top:15%;left:9%;z-index: 2;}
  .backgroundImg{opacity:30%;margin-left:70%;margin-top:15%; height:40%;
      -webkit-transform:rotate(30deg);
      -moz-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
      -o-transform: rotate(30deg);
      transform: rotate(30deg);
  position: absolute;z-index: 0;}
  .backgroundPanel{background-color: #6375D7; width:100%;height:700px;}
  .galleryBtn,.controlBtn{float: right; margin-left: 10px;margin-bottom:15px;}
  .dropdown{float: left;margin-right:10px;margin-left:10px;}
  .dropdown-item:hover{background-color:#245edb;}
  .postSyncBtnAllResp{float: right;padding-right: 12px;}
  .task:hover{text-decoration: underline;}`]
})
export class DataComponent implements OnInit, OnDestroy, OnChanges {

    private _isLoading = true;

    private _subscription;

    private _errorMessage;

    private _appContext: ApplicationContext;

    // Kugan

    private intentModel:(Project|Client) = new Project();

    private formModel:FormModel;

    private _totalRespondents:number;

    private availableTerminals:string[];

    private availablePhysicalDevices:string[];

    private _deviceID:number;

    private selectedResultsPerPage = 25;

    private singleRespondentView = false;

    private _questionnaire:Questionnaire;

    @ViewChild (ReportsComponent) private reportsComponent:ReportsComponent;

    @ViewChild (ReportFilterComponent) private reportFilterComponent:ReportFilterComponent;

    @ViewChild (RegisterDeviceComponent) private registerDevice:RegisterDeviceComponent;

    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;

    @ViewChild (FileChooserComponent) private fileChooser:FileChooserComponent;

    @ViewChild(CreateObjectDialogComponent) private createProjectComponent:CreateObjectDialogComponent;

    @ViewChild(ClientManagerComponent) private clientManagerComponent:ClientManagerComponent;

    @ViewChild(NotificationComponent) private notificationComponent:NotificationComponent;

    private _respondentQueryTerminated = false;



    constructor(private _projectService: ProjectService, private _route: ActivatedRoute, private router: Router,private _translate:TranslateService) {
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this._appContext != null) {
                    localStorage.setItem('nav_' + this._appContext.questionnaire.id, JSON.stringify(this._appContext.dataNavigationState));
                    localStorage.setItem('sf_' + this._appContext.questionnaire.id, JSON.stringify(this._appContext.searchFilters));
                }
            }
        });
    }

    onSearchFilterChange() {
        this._isLoading = true;
        this._respondentQueryTerminated = false;

        this._projectService.getRespondents(this._appContext.questionnaire.id, this._appContext.searchFilters).subscribe(data => {
            this._appContext.synchros = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(data,Synchro);
            this._respondentQueryTerminated = true;
        },
        error => this._errorMessage = <any>error);

        this._projectService.getStatistics(this._appContext.questionnaire.id, this._appContext.searchFilters).then(statistics => {
            this._appContext.statistics = statistics;
            this._isLoading = false;
        },
            error => this._errorMessage = <any>error);

        return true;
    }

    onExcelReport() {
        /*const saveAs = require('file-saver');
        this._projectService.excelReport(this._appContext.questionnaire.id, this._appContext.searchFilters)
            .subscribe(data => {
                    saveAs.saveAs(data, 'report-'+Date.now()+'.xls');
            },
            error => console.log('Error downloading the file.'));*/
        this.reportsComponent.showReportFilterModal();
    }

    onExcelReportQuickLink() {
        this._appContext.dataNavigationState.selectedView = 'quickLinkExcelReport';
        this.reportsComponent =  new ReportsComponent(this._projectService,this._translate);
        if(this._appContext == null) {
           alert('appContext is undefined.');
        }
        this.reportFilterComponent.toggleFilter();
        /*this.reportsComponent.prepareQuickLinkExcelReport();
        this.availablePhysicalDevices = this.reportsComponent.getAvailablePhysicalDevices();
        this.availableTerminals = this.reportsComponent.getAvailableTerminals();
        this.reportsComponent = null;*/
        /*while(this.reportsComponent == null) {
        }*/
    }

    // TODO: Eventually implement html reporting service. Wondering how it will be used
    onHtmlReport() {

        this._appContext.dataNavigationState.selectedView = 'htmlRapport';
        // this.ReportHtml.emit();
    }

    changeRespondentView(view) {
        this._respondentQueryTerminated = false;
        this._appContext.dataNavigationState.respondentsView = view;
        this._deviceID =-1;
        this.getTotalNumberOfRespondents(parseInt(sessionStorage.getItem('questionnaire_id'), 10));

    }

    onDownload(mediaQuestion: MediaQuestion) {
        const saveAs = require('file-saver');
        this._projectService.downloadFile(this._appContext.questionnaire.id, mediaQuestion.type, mediaQuestion.questionNo, this._appContext.searchFilters)
            .subscribe(data => {
                    saveAs.saveAs(data, mediaQuestion.type + '.zip');
            },
            error => console.log('Error downloading the file.'));
    }

    ngOnInit(): void {

        this.formModel = ProjectFormUtil.generateProjectForm();
        this._subscription = this._route.params.subscribe(params => {
            this._respondentQueryTerminated = false;
            const id = params['id'];
            const qid = params['qid'];

            if (id && qid) {
                this._projectService.getQuestionnaire(qid).subscribe(questionnaire => {
                    const navigationStateJson = localStorage.getItem('nav_' + qid);
                    const searchFiltersJson = localStorage.getItem('sf_' + qid);

                    sessionStorage.setItem('project_id', id);
                    sessionStorage.setItem('questionnaire_id', qid);

                    let navigationState: DataNavigationState;
                    let searchFilters: SearchFilters;

                    if (navigationStateJson != null && searchFiltersJson != null) {
                        navigationState = JSON.parse(navigationStateJson) as DataNavigationState;
                        searchFilters = new SearchFilters();
                        // searchFilters.initFromJson(JSON.parse(searchFiltersJson));
                    } else {
                        navigationState = new DataNavigationState();
                        searchFilters = new SearchFilters();
                    }

                    this._questionnaire = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(questionnaire,Questionnaire);
                    this._appContext = new ApplicationContext(this._questionnaire, navigationState, searchFilters);

                    this._projectService.getRespondents(qid, this._appContext.searchFilters).subscribe(data => {
                        let  synchros = [];
                        synchros = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(data,Synchro);
                        this._appContext.setSynchrosAndInitSynchrosForSearch(synchros);
                        this._respondentQueryTerminated = true;
                        this._appContext.synchros = synchros;
                    },
                        error => this._errorMessage = <any>error);



                    this.getTotalNumberOfRespondents(qid);

                    this._projectService.getStatistics(this._appContext.questionnaire.id, this._appContext.searchFilters).then(statistics => {
                        this._appContext.statistics = statistics;
                        this._isLoading = false;
                    },
                        error => this._errorMessage = <any>error);
                },
                    error => this._errorMessage = <any>error);
            }
        });
    }

    ngOnDestroy() {
        this._subscription.unsubscribe();
    }

    ngOnChanges() {
        this._respondentQueryTerminated = false;
        console.log('on project component change');
    }

    explodeSynchro(synchro:Synchro): void {
        this._deviceID = synchro.deviceId;
        this._totalRespondents = synchro.totalNumberOfRespondents;
        this._appContext.dataNavigationState.respondentsView = 'by-list';

    }

    private getTotalNumberOfRespondents(qid:number) {
        this._projectService.getNbRespondent(qid).then(totalNbRespondents => {
                this._totalRespondents = totalNbRespondents;
            },
            error => this._errorMessage = <any>error);
    }

  onSelected(event: any) {
      this.selectedResultsPerPage = event.target.value;
  }

  singleRespondentSelected(val:boolean) {
      this.singleRespondentView = val;
  }

  galleryViewer() {
    this.router.navigate(['/gallery',sessionStorage.getItem('project_id'),sessionStorage.getItem('questionnaire_id')]);
  }

  executePostSynchro() {
        this._projectService.executePostSyncOnAllRespondents(-1,sessionStorage.getItem('questionnaire_id'),-1).subscribe(res=> {
            if(res.includes('200')) {
                this.genericModal.defineModal('Post Synchro executed successfully!','Device Registration',100);
            } else {
                this.genericModal.defineModal('Some error occurred while executing post syncho!','Device Registration',350);
            }
            this.genericModal.toggleModal();
        });
    }
    DeviceRegistered(data:string) {
        if(data.includes('350')) {
            this.genericModal.defineModal(data,'Device Registration',350);
        } else {
            this.genericModal.defineModal(data,'Device Registration',100);
        }
        this.genericModal.toggleModal();
    }

    RegisterDevice() {
        this.registerDevice.toggleDialog();
    }

    onOk() {

        this.genericModal.toggleModal();
    }

    getRegisteredDevices() {
        this.fileChooser.toggleFileChooser('devices');
    }

    private onReport() {
        this._appContext.dataNavigationState.selectedView = 'report';
    }

    private showAddProject() {
        this.intentModel = new Project();
        this.formModel = ProjectFormUtil.generateProjectForm();
        this.createProjectComponent.toggleDialog();
    }

    private launchClientManager() {
        this.clientManagerComponent.toggleDialog();
    }
    private showAddClient() {
        this.intentModel = new Client();
        this.formModel = ClientFormUtil.generateClientForm();
        this.createProjectComponent.toggleDialog();
    }

    onNewEvent(event:string) {
        switch (event) {
            case 'project': this.createProjectComponent.toggleDialog();window.location.reload();break;
            case 'client': this.createProjectComponent.toggleDialog();break;
        }
    }

    errorThrow(data: any) {
        if(data.includes('350')) {
            this.genericModal.defineModal(data,'data',350);
        } else {
            this.genericModal.defineModal(data,'data',100);
        }
    }
}
